// extracted by mini-css-extract-plugin
module.exports = {"container":"Press_container__I736D","inner":"Press_inner__fQ1f0","title":"Press_title__K5YYS","images":"Press_images___gsmh","pressLogo":"Press_pressLogo__kiFFf"};